

import { Time } from '@angular/common';
import { Observable } from 'rxjs';
import { Parameter } from '../common/parameter';
import * as TimeSpan from 'timespan';
import { Physician } from '../masters/physician-mst';

export interface DoctorsScheduleParameter extends Parameter {
    searchTerm: number;
    orderBy: string;

}

export interface DoctorsSchedule {
    id?: any;
    tenantId: any;
    branchId: any;
    doctorId: any;

    startTime: any;
    endTime: any;
    startDate: Date;
    endDate: Date;
    timeSlotInMin: number;
    dayOfWeek: string;
    physician?: Physician;
    branch?:any;
    parameters?: DoctorsScheduleParameter[];
    links?: any;
    noOfSlots?: number;
    noOfSlotsFromMobileApp?: number;
    IsVaccineAppt?:boolean;
}


export abstract class DoctorsScheduleData {
    abstract getById(url: string): Observable<any>;
    abstract list(url: string): Observable<DoctorsSchedule[]>;
    abstract create(url: string, data: DoctorsSchedule[]): Observable<DoctorsSchedule>;
    abstract bulkUpdate(url: string, data: DoctorsSchedule[]): Observable<DoctorsSchedule>;
    abstract update(url: string, data: DoctorsSchedule): Observable<DoctorsSchedule>;
    abstract delete(url: string): Observable<any>;
}